import { render, staticRenderFns } from "./Ips.vue?vue&type=template&id=037f1cb2&scoped=true&"
import script from "./Ips.vue?vue&type=script&lang=js&"
export * from "./Ips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037f1cb2",
  null
  
)

export default component.exports